import React, { useState } from "react";
import Arrow from "../../../assets/images/arrow-right.svg";
import { SectionSlider } from "../../../components/SectionSlider/SectionSlider";
import { Link } from "react-router-dom";
import FlickitySlider from "../../../components/FlickitySlider/FlickitySlider";
import { useQuery } from "@apollo/react-hooks";
import { GET_HOME_SLIDER, GET_HOME_INFO } from "../../../queries/homeTopSectionQuery";
import "./HomeTopSection.scss";

export const HomeTopSection = () => {
  const [sliderStatus] = useState("started");
  const { data: sliderData, loading: loadingSlider } = useQuery(GET_HOME_SLIDER);
  const { data: infoData, loading: loadingInfo } = useQuery(GET_HOME_INFO);

  if (loadingSlider || loadingInfo) return <p className="text-center">...</p>;

  const sliderItems = sliderData?.themeOptions?.homePageSlider?.sliderItems || [];
  const homeInfo = infoData?.themeOptions?.homePageInfo?.info || [];

  return (
    <div className="HomeTopSection">
      <div className="home-top-section__image">
        {sliderItems.length > 0 && <SectionSlider data={sliderItems} />}
      </div>
      <div className="feature-boxs-row hidden-sm">
        {homeInfo.map((info, index) => (
          <div key={index}>
            <div className="feature-box-desktop">
              <img className="feature-box-image" src={info?.photo?.mediaItemUrl} alt="" />
            </div>
          </div>
        ))}
      </div>
      <div className="row d-flex feature-boxs-row show-sm">
        <div id="inner-wrapper" className="inner-wrapper">
          <span className={sliderStatus === "started" ? "right-gradient" : "left-gradient"}></span>
          {homeInfo.length > 0 && (
            <FlickitySlider options={{ freeScroll: true, contain: true, prevNextButtons: false, pageDots: false }}>
              {homeInfo.map((info, index) => (
                <div key={`home-info-${index}`} className="feature-box">
                  <img src={info?.mobilePhoto?.mediaItemUrl} alt="" />
                  <div className="details-box">
                    <div className="title">{info.title}</div>
                    <div className="subtitle">{info.subtitle}</div>
                  </div>
                  {info.link && <Link to={info.link} className="more-mob">Më shumë <img className="arrow-right" src={Arrow} alt="" /></Link>}
                </div>
              ))}
            </FlickitySlider>
          )}
        </div>
      </div>
    </div>
  );
};
